"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.select = void 0;
var Select_hbs_1 = __importDefault(require("./Select.hbs"));
require("./select.scss");
var select = {
    init: function () {
        select.renderSelects();
        select.addEventListeners();
    },
    renderSelects: function () {
        var selects = document.querySelectorAll("[js-select]");
        if (selects.length > 0) {
            selects.forEach(function (select, index) {
                var selectItem = select;
                var optionItems = [];
                var isSearchable = select.attributes.getNamedItem("searchable") ? true : false;
                var dataLabels = {
                    "titleLabel": select.getAttribute("data-label-title"),
                    "chooseLabel": select.getAttribute("data-label-choose"),
                    "selectedLabel": select.getAttribute("data-label-selected"),
                    "optionLabel": select.getAttribute("data-label-option"),
                    "optionsLabel": select.getAttribute("data-label-options"),
                    "searchLabel": select.getAttribute("data-label-search")
                };
                var selectData = {
                    "id": "select-".concat(index),
                    "name": selectItem.name,
                    "multiple": selectItem.multiple,
                    "searchable": isSearchable,
                    "options": optionItems,
                    "labels": dataLabels
                };
                Array.prototype.forEach.call(selectItem.options, function (option) {
                    var val = option.value;
                    var txt = option.textContent;
                    optionItems.push({ value: val, textValue: txt });
                });
                var selectWrapperNode = document.createElement("div");
                selectWrapperNode.setAttribute("js-select", "");
                selectWrapperNode.setAttribute("name", selectData.name);
                selectWrapperNode.id = selectData.id;
                selectWrapperNode.classList.add("select");
                select.insertAdjacentElement("beforebegin", selectWrapperNode);
                var targetElement = document.getElementById(selectData.id);
                if (targetElement) {
                    targetElement.innerHTML = (0, Select_hbs_1.default)(selectData);
                    select.remove();
                }
            });
        }
    },
    addEventListeners: function () {
        var selectItems = document.querySelectorAll("[js-select]");
        var toggleSelectButton = document.querySelectorAll("[js-select-toggle]");
        var optionItems = document.querySelectorAll("[js-select-item]");
        var clearFilterButtons = document.querySelectorAll("[js-clear-filter]");
        var searchInput = document.querySelectorAll("[js-select-search]");
        selectItems.forEach(function (selectItem) {
            selectItem.addEventListener("click", function (e) {
                var target = e.target;
                if (target) {
                    if (target.classList.contains("expanded")) {
                        select.toggleSelect(target, false);
                    }
                }
            });
        });
        toggleSelectButton.forEach(function (selectButton) {
            selectButton.addEventListener("click", function (e) {
                e.preventDefault();
                var target = e.target;
                if (target) {
                    var parent_1 = target.closest("[js-select]");
                    if (parent_1) {
                        if (!parent_1.classList.contains("expanded")) {
                            select.toggleSelect(parent_1, true);
                        }
                        else {
                            select.toggleSelect(parent_1, false);
                        }
                    }
                }
            });
        });
        optionItems.forEach(function (optionItem) {
            optionItem.addEventListener("click", function (e) {
                var target = e.target;
                if (target) {
                    select.toggleOptionItem(target);
                }
            });
        });
        clearFilterButtons.forEach(function (clearFilterButton) {
            clearFilterButton.addEventListener("click", function (e) {
                e.preventDefault();
                var target = e.target;
                var currentSelect = target.closest("[js-select]");
                if (target) {
                    select.clearOptions(currentSelect);
                }
            });
        });
        if (searchInput.length > 0) {
            searchInput.forEach(function (input) {
                input.addEventListener("keyup", function (e) {
                    var target = e.target;
                    var parent = target.closest("[js-select-panel]");
                    var userInputFilter = target.value.toUpperCase();
                    if (parent) {
                        var elements = parent.querySelectorAll("[js-select-item]");
                        if (elements.length > 0) {
                            elements.forEach(function (element) {
                                var item = element;
                                var selectItem = item.querySelector("span");
                                if (selectItem !== null) {
                                    var selectItemProcessed = selectItem.innerText.toUpperCase();
                                    if (selectItemProcessed.indexOf(userInputFilter) > -1) {
                                        item.style.display = "";
                                    }
                                    else {
                                        item.style.display = "none";
                                    }
                                }
                            });
                        }
                    }
                });
            });
        }
    },
    toggleSelect: function (elem, expanded) {
        if (expanded) {
            elem.classList.add("expanded");
        }
        else {
            elem.classList.remove("expanded");
        }
    },
    toggleOptionItem: function (elem) {
        var parent = elem.closest("[js-select]");
        var isMultiSelect = elem.classList.contains("multiple");
        if (isMultiSelect) {
            elem.classList.toggle("checked");
        }
        else {
            if (!elem.classList.contains("checked")) {
                var previousSelectedItem = parent.querySelector(".checked");
                if (previousSelectedItem) {
                    previousSelectedItem.classList.remove("checked");
                }
                elem.classList.add("checked");
                select.toggleSelect(parent, false);
            }
        }
        if (parent) {
            var items = parent.querySelectorAll("[js-select-item].checked");
            if (isMultiSelect) {
                select.setLabels(parent, items.length, true);
            }
            else {
                select.setLabels(parent, 1, false);
            }
        }
    },
    clearOptions: function (currentSelect) {
        var checkedItems = currentSelect.querySelectorAll("[js-select-item].checked");
        if (checkedItems.length > 0) {
            checkedItems.forEach(function (checkedItem) {
                checkedItem.classList.remove("checked");
                select.setLabels(currentSelect, 0, true);
                select.toggleSelect(currentSelect, false);
            });
        }
    },
    setLabels: function (currentSelect, amount, isMultiSelect) {
        var clearFilterButton = currentSelect.querySelector("[js-clear-filter]");
        var labelContainer = currentSelect.querySelector("[js-select-title]");
        var selectTitleLabel = labelContainer.getAttribute("data-label-title");
        var selectSelectedLabel = labelContainer.getAttribute("data-label-selected");
        var selectOptionLabel = labelContainer.getAttribute("data-label-option");
        var selectOptionsLabel = labelContainer.getAttribute("data-label-options");
        if (isMultiSelect) {
            switch (amount) {
                case 0:
                    if (selectTitleLabel) {
                        labelContainer.innerText = selectTitleLabel;
                    }
                    else {
                        labelContainer.innerText = "Select option";
                    }
                    clearFilterButton.style.display = "none";
                    break;
                case 1:
                    if (selectOptionLabel && selectSelectedLabel) {
                        labelContainer.innerText = amount + " " + selectOptionLabel + " " + selectSelectedLabel;
                    }
                    else {
                        labelContainer.innerText = amount + " option selected";
                    }
                    clearFilterButton.style.display = "flex";
                    break;
                default:
                    if (selectOptionsLabel && selectSelectedLabel) {
                        labelContainer.innerText = amount + " " + selectOptionsLabel + " " + selectSelectedLabel;
                    }
                    else {
                        labelContainer.innerText = amount + " options selected";
                    }
                    clearFilterButton.style.display = "flex";
            }
        }
        else {
            var selectedItem = currentSelect.querySelector(".checked span");
            switch (amount) {
                case 0:
                    if (selectTitleLabel) {
                        labelContainer.innerText = selectTitleLabel;
                    }
                    else {
                        labelContainer.innerText = "Select option";
                    }
                    clearFilterButton.style.display = "none";
                    break;
                default:
                    if (selectedItem) {
                        var selectedTitle = selectedItem.textContent;
                        if (selectedTitle) {
                            labelContainer.innerText = selectedTitle;
                        }
                    }
                    clearFilterButton.style.display = "flex";
            }
        }
    }
};
exports.select = select;
